<button
  nz-button
  nzType="default"
  nzSize="large"
  class="feedback-button  desktop-button"
  [class.pulse]="showPulse()"
  [disabled]="feedbackOpen()"
  nz-tooltip
  [attr.nzTooltipTitle]="'common.send_feedback_ctrlshiftf' | translate"
  nzTooltipPlacement="left"
  (click)="openFeedbackModal()"
  (keydown)="handleKeydown($event)"
  tabindex="0"
  role="button"
  [attr.aria-label]="'common.send_feedback' | translate"
>
  <span nz-icon nzType="message" nzTheme="outline"></span>
  <span class="feedback-button__label">{{ 'common.send_feedback' | translate }}</span>
</button>
